export default "__VITE_ASSET__B2S6l5Qn__"